import Swiper, { Autoplay, Pagination, EffectFade } from 'swiper'
import 'swiper/swiper-bundle.css'


Swiper.use([Autoplay, Pagination, EffectFade])

const lastProjectsHomepage = new Swiper('.last-projects-caroussel', {
  loop: false,
  spaceBetween: 20,
  slidesPerView: 1.5,

  breakpoints: {
    768: {
      enabled: false,
      slidesPerView: 2,
    },
  },
})

lastProjectsHomepage


// WEBPACK FOOTER //
// ./scripts/components/lastProjectsHomepage.js